var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "white",
    stroke: "#52DD91",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73047 17.7812C10.0039 18.0547 10.4688 18.0547 10.7422 17.7812L18.7812 9.74219C19.0547 9.46875 19.0547 9.00391 18.7812 8.73047L17.7969 7.74609C17.5234 7.47266 17.0859 7.47266 16.8125 7.74609L10.25 14.3086L7.16016 11.2461C6.88672 10.9727 6.44922 10.9727 6.17578 11.2461L5.19141 12.2305C4.91797 12.5039 4.91797 12.9688 5.19141 13.2422L9.73047 17.7812Z",
    fill: "#52DD91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.62b0d7a0a0c4b1ad5e325b275b3e0d3d.svg";
export { ForwardRef as ReactComponent };